export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9442.d6184188.jpg";